<template>
    <table>
        <tbody>
            <tr>
                <th></th>
                <th class="row_head sun">朝発バス</th>
                <th class="row_head moon">夜発バス</th>
                <th class="row_head bullet">新幹線</th>
            </tr>
            <tr v-for="(date, dateKey) in dateList">
                <th class="line_head">{{date.format("YYYY年M月")}}</th>
                <td v-for="(trans, transKey) in transList">
                    <a :href="'/search/' + apiUrlList[trans.id][dateKey]">{{priceList[trans.id][dateKey]}}</a>
                </td>
            </tr>
        </tbody>
    </table>
    <vue-element-loading :active="isLoading"  :is-full-screen="false"/>
</template>

<script>
    import { ref, onMounted } from 'vue'
    export default ({
        props: {
            // 引数の受け問
            departure_area : {type: String, require: true},
            departure_pref : {type: String, require: true},
            first_date : {type: String, require: true},
            trans_list : {type: String, require: true},
        },
        setup (props, context) {
            const isLoading = ref(true)

            let departureArea = JSON.parse(props.departure_area)
            let transList = JSON.parse(props.trans_list)
            transList.pop()
            let departurePref = JSON.parse(props.departure_pref)

            let firstDate = dayjs(props.first_date)
            let dateList=[]
            dateList[0] = dayjs(firstDate)
            dateList[1] = dayjs(firstDate.add(1, "months"))
            dateList[2] = dayjs(firstDate.add(1, "months"))
            dateList[3] = dayjs(firstDate.add(1, "months"))

            const priceList = ref([])
            let apiUrlList = []
            Object.keys(transList).forEach(function (transKey) {

                if (transKey == 3) return;

                priceList.value[transList[transKey].id] = []
                apiUrlList[transList[transKey].id] = []

                Object.keys(dateList).forEach(function (dateKey) {
                    priceList.value[transList[transKey].id][dateKey] = "読込中"

                    let parrentAreaSlug = departureArea[Object.entries(departurePref.parentIdList)[0][1]].slug

                    let paramList = [
                        "deptArea_" + parrentAreaSlug,
                        "deptPref_" + departurePref.slug,
                        "tran_" + transList[transKey].slug,
                        "date_" + dateList[dateKey].format("YYYYMM"),
                    ]
                    paramList = paramList.filter(Boolean)
                    apiUrlList[transList[transKey].id][dateKey] = paramList.join("/")
                })
            })

            // 完了時
            onMounted(() => {
                let urlList = []
                Object.keys(apiUrlList).forEach(function (transKey) {
                    Object.keys(apiUrlList[transKey]).forEach(function (dateKey) {
                        urlList.push(apiUrlList[transKey][dateKey])
                    })
                })

                if(urlList.length == 0) {
                    isLoading.value = false
                    return;
                }

                axios.post("/api/bestPrice/", {
                    urlList: urlList,
                })
                .then(function (response) {
                    Object.keys(apiUrlList).forEach(function (transKey) {
                        Object.keys(apiUrlList[transKey]).forEach(function (dateKey) {
                            let bestPrice = null
                            if (response.data.bestPriceList[apiUrlList[transKey][dateKey]] != null){
                                bestPrice = response.data.bestPriceList[apiUrlList[transKey][dateKey]] .price
                            }

                            if (bestPrice) {
                                priceList.value[transKey][dateKey] = bestPrice.toLocaleString() + "円～"
                            } else {
                                priceList.value[transKey][dateKey] = "-"
                            }
                        })
                    })

                    isLoading.value = false
                })
            })

            return {
                dateList,
                transList,
                priceList,
                apiUrlList,
                isLoading,
            }
        },
    })
</script>